// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footer__icon":"footer_footer__icon__usrCh","footer__main-menu":"footer_footer__main-menu__rbgEX"};